/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import { Popconfirm } from 'components';

import FormContext from '../../FormContext';
import { AlertRightItems, LinkButton, StyledAlert } from '../../components';
import { REQUEST_TRANSFER_TEXT } from '../../constants';

interface IncomingSuggestedTransferAlertProps {
  requestTransfer: () => Promise<void>;
}
const IncomingSuggestedTransferAlert = ({
  requestTransfer,
}: IncomingSuggestedTransferAlertProps) => {
  const {
    working,
    branchValid,
    addressValid,
    firstNameValid,
    lastNameValid,
    emailValidity,
    memberNumbersAllValid,
    mobileValid,
    memberNumberStateLoading,
  } = useContext(FormContext);

  return (
    <StyledAlert
      message={
        <span>
          You must complete the required fields before you can transfer this
          agent
        </span>
      }
      action={
        <AlertRightItems>
          <Popconfirm
            title={REQUEST_TRANSFER_TEXT}
            okText="Yes"
            cancelText="No"
            onConfirm={requestTransfer}
            disabled={
              !branchValid ||
              !addressValid ||
              !memberNumbersAllValid ||
              !mobileValid ||
              working
            }
            width={336}
            placement="bottomRight"
          >
            <LinkButton
              disabled={
                !branchValid ||
                !addressValid ||
                !firstNameValid ||
                !lastNameValid ||
                !emailValidity.isValid ||
                !memberNumbersAllValid ||
                !mobileValid ||
                memberNumberStateLoading
              }
            >
              Request Transfer
            </LinkButton>
          </Popconfirm>
        </AlertRightItems>
      }
      type="info"
      showIcon
    />
  );
};

export default IncomingSuggestedTransferAlert;
